<div class="outer-container" [style.--dynamic-min-hight]="(minHeight ||'') + 'px'">
  <app-ribbon *ngIf="showRibbon"></app-ribbon>
  <app-widget-header [titleText]="title" [subTitleText]="subtitle" [tooltipText]="tooltip" [control]="control"
    [selectMode]="selectMode" [selectOptions]="selectOptions" [iconPath]="iconPath" [placeholder]="placeholder"
    [searchable]="searchable" [compareWith]="compareWith" [selectDisabled]="selectDisabled" [selectWidth]="selectWidth"
    [selectDropdownWideWidth]="selectDropdownWideWidth" [selectSearchPlaceholder]="selectSearchPlaceholder"
    [hideSelected]="hideSelected" [selectAllAndClearOptions]="selectAllAndClearOptions"
    [groupBySelected]="groupBySelected" [showAllSelected]="showAllSelected" [showSelectedIcon]="showSelectedIcon"
    [showPlaceholderAllSelected]="showPlaceholderAllSelected" [showPlaceholderIcon]="showPlaceholderIcon"
    [secondControl]="secondControl" [secondSelectOptions]="secondSelectOptions" [secondPlaceholder]="secondPlaceholder"
    [secondSelectWidth]="secondSelectWidth" [secondSelectSearchPlaceholder]="secondSelectSearchPlaceholder"
    [askPolarisWidget]="askPolarisWidget" [selectedMetrics]="selectedMetrics" (apply)="onApply()">
  </app-widget-header>
  <div class="content-wrapper">
    <div [class]="(alignCenter?'widget-container centered':'widget-container')">
      <ng-content></ng-content>
    </div>
  </div>
</div>
